import { Partner } from './partner';
import { Shipment } from './shipment';

export interface Patient {
  name?: string;
  phoneNo?: string;
}

export interface Phase {
  id?: string;
  createdAt?: string;
  name?: 'BLUEPRINT' | 'SPOON';
  status?: 'IN_PROGRESS' | 'DONE';
  flagged?: boolean;
  description?: string;
  attachments?: any[];
}

export interface Case {
  id?: string;
  createdAt?: string;
  status?: string;
  patient?: Patient;
  doctor?: Partner;
  tech?: Partner;
  doctorId?: number;
  techId?: number;
  phases?: Phase[];
  shipments?: Shipment[];
}

/** Every value of the backend's CaseStatus enum, in workflow order. */
export const CASE_STATUSES = ['NEW', 'REQUESTED', 'IN_PROGRESS', 'ON_HOLD', 'DONE', 'DECLINED'];

/** '' hides archived cases (the backend default), 'include' adds them, 'only' shows nothing else. */
export type ArchiveMode = '' | 'include' | 'only';

export interface CasesQueryParams {
  page?: number;
  size?: number;
  sort?: string[];
  doctorId?: number;
  techId?: number;
  searchTerm?: string;
  /** Sent as repeated `status=` params; the backend ORs them. */
  statuses?: string[];
  createdAtFrom?: string;
  createdAtTo?: string;
  includeArchived?: boolean;
  archivedOnly?: boolean;
  /**
   * Not a query param — travels as the X-T-ID header, which is what makes the backend apply its own
   * tenant predicate (doctor.id = tenant OR tech.id = tenant). Omit it to query every tenant.
   */
  tenantId?: number | string;
}